import React, { useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { info, main_links, more_links, socials } from "../data/links";
import master from "../assets/master.png";
import visa from "../assets/visa.png";
import paypal from "../assets/paypal.png";
import express from "../assets/express.png";
import logo from "../assets/logo.png";
import location from "../assets/icons/location.png";
import email from "../assets/icons/email.png";
import call from "../assets/icons/call.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const footerRef = useRef(null);
  const navigate = useNavigate();
  // useEffect(() => {
  // Animate all direct children inside footer
  // const sections = gsap.utils.toArray("#footer-sections > div");

  //   gsap.set(sections, { opacity: 0, y: 50 });

  //   ScrollTrigger.batch(sections, {
  //     onEnter: (batch) => {
  //       gsap.to(batch, {
  //         opacity: 1,
  //         y: 0,
  //         stagger: 0.2,
  //         duration: 1,
  //         ease: "power3.out",
  //       });
  //     },
  //     start: "top 85%", // when top of section hits 85% of viewport
  //     once: false, // animate every scroll
  //     onLeaveBack: (batch) => {
  //       gsap.to(batch, {
  //         opacity: 0,
  //         y: 50,
  //         stagger: 0.1,
  //         duration: 0.8,
  //         ease: "power3.out",
  //       });
  //     },
  //   });
  // }, []);

  return (
    <div
      // ref={footerRef}
      className="w-full h-full bg-white  px-[1rem] sm:px-[4rem] pt-[5rem]"
    >
      <div
        id="footer-sections"
        className="flex justify-center items-center gap-[4rem] flex-wrap"
      >
        {/* Section 1: Logo + Description + Payment */}
        <div className="w-[100%] md:w-[280px] flex justify-start items-start flex-col gap-[1.5rem]">
          <div
            className="logo h-[70px] w-[200px] bg-black px-4 rounded-[50px] flex-shrink-0 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img
              src="/images/logo.png"
              alt="Logo"
              className="h-full w-full sm:w-[130px] md:w-auto object-contain"
            />
          </div>
          <p className="font-light text-[18px] text-gray-800">
            Aruhi Fragrances LLC | Founded in 2025 in New Jersey, we are an
            online fragrance retailer dedicated to offering high-quality
            products, competitive prices, and exceptional customer service.
          </p>
          <div className="flex flex-wrap justify-start items-center gap-[1.5rem]">
            <img src="/images/visa.png" alt="" />
            <img src="/images/express.png" alt="" />
            <img src="/images/master.png" alt="" />
            <img src="/images/paypal.png" alt="" />
          </div>
        </div>

        {/* Section 2: Main Links */}
        <div className="w-[100%] md:w-[280px] flex justify-end items-start flex-col gap-[1.5rem]">
          <h1 className="font-bold text-[20px] text-gray-800">Main Links</h1>
          <div className="flex justify-start items-start flex-col gap-[0.8rem]">
            {main_links.map((data, index) => (
              <a
                key={index}
                onClick={() => navigate(data.link)}
                className="text-gray-800 text-[18px]  cursor-pointer"
              >
                {data.title}
              </a>
            ))}
          </div>
        </div>

        {/* Section 3: Quick Links */}
        <div className="w-[100%] md:w-[280px]  flex justify-center mt-[-1rem] items-start flex-col gap-[1.5rem]">
          <h1 className="font-bold text-[20px] text-gray-800">Quick Links</h1>
          <div className="flex justify-start items-start flex-col gap-[0.8rem]">
            {more_links.map((data, index) => (
              <Link
                key={index}
                to={data.link}
                className="text-gray-800 text-[18px] "
              >
                {data.title}
              </Link>
            ))}
          </div>
        </div>

        {/* Section 4: Contact + Socials */}
        <div className="w-[100%] md:w-[280px] flex justify-center mt-[2.5rem] items-start flex-col gap-[1.5rem]">
          <h1 className="font-bold text-[20px] text-gray-800">Reach Us Out</h1>
          <div className="flex justify-start items-start flex-col gap-[0.8rem]">
            <div className="flex items-start justify-start gap-[0.5rem]">
              <img src={call} alt="" />
              <a
                href="tel:+18486670850"
                className="text-[18px] font-light text-gray-800"
              >
                (848) 667-0850
              </a>
            </div>
            <div className="flex items-start justify-start gap-[0.5rem]">
              <img src={email} alt="" />
              <div className="text-[18px] font-light text-gray-800">
                <a
                  href="https://mail.google.com/mail/?view=cm&to=info@aruhifragrances.com"
                  target="_blank"
                >
                  info@aruhifragrances.com
                </a>
                ,{" "}
                <a
                  href="https://mail.google.com/mail/?view=cm&to=wholesale@aruhifragrances.com"
                  target="_blank"
                >
                  wholesale@aruhifragrances.com
                </a>
              </div>
            </div>
            <div className="flex items-start justify-start gap-[0.5rem]">
              <img src={location} alt="" />
              <p className="text-[18px] font-light text-gray-800">
                1514 Azalea Dr North Brunswick Township, NJ 08902 USA
              </p>
            </div>
          </div>

          <div className="flex justify-start items-start flex-col gap-[0.2rem]">
            <h1 className="font-bold text-[20px] text-gray-800">Follow Us</h1>
            <div className="flex justify-start items-center gap-[1.5rem] p-2">
              {socials.map((data, index) => (
                <img
                  onClick={() => window.open(data.link, "_blank")}
                  key={index}
                  src={data.icon}
                  className="cursor-pointer"
                  style={{ width: "30px" }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div
        className="w-full h-[2px] rounded-full mt-[2rem]"
        style={{
          background:
            "linear-gradient(147.2deg, #DCBA45 0.83%, #FFE568 25.03%, #E8B641 55.47%, #D8AD42 78.88%)",
        }}
      />

      {/* Bottom row */}
      <div className="flex justify-between items-center px-2 py-[1rem]">
        <p className="text-[18px] font-light text-gray-800">
          © 2026 Copyright | Aruhi Fragrances | All Rights Reserved
        </p>
        <p className="text-[18px] font-light text-gray-800">
          Powered By{" "}
          <a
            target="_blank"
            href="https://designversestudios.com/"
            className="text-gray-800"
          >
            Design Verse Studios{" "}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
